import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Photos } from './Photos';
import {Globals} from '../globals';
@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss']
})
export class PhotosComponent implements OnInit {
photos: Photos;
somethingChanged: any;
dataToSend:any;
p: any = 1;
collection: any[]=[];
  config2: any = {
    //  effect:'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: false,

    zoomToggle: false,
    setWrapperSize: true,

  };
 today: any;
 todays: any;

  dateChanged(val: any) {
    var num;
    // console.log('Date changed', val);
    this.somethingChanged = val.value.toString().split(" ");
    // console.log(this.somethingChanged);
    if(this.somethingChanged[1] == "Jan") {
      num = '01';
    } else if(this.somethingChanged[1] == "Feb") {
      num = '02';
    }
    else if(this.somethingChanged[1] == "Mar") {
      num = '03';
    }
    else if(this.somethingChanged[1] == "Apr") {
num = '04';
    }
    else if(this.somethingChanged[1] == "May") {
num = '05';
    }
    else if(this.somethingChanged[1] == "Jun") {
num = '06';
    }
    else if(this.somethingChanged[1] == "Jul") {
num = '07';
    }
    else if(this.somethingChanged[1] == "Aug") {
num = '08';
    }
    else if(this.somethingChanged[1] == "Sep") {
num = '09';
    }
    else if(this.somethingChanged[1] == "Oct") {
num = '10';
    }
    else if(this.somethingChanged[1] == "Nov") {
num = '11';
    }
    else if(this.somethingChanged[1] == "Dec") {
num = '12';
    }
this.dataToSend = this.somethingChanged[3] + "-"+num + "-"+ this.somethingChanged[2]
    // console.log(this.dataToSend)
    this.http.get<Photos>(this.globals.urlMain +'pictures', {
      params:{
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.photos = data;
      var k =Number(data.data.item.pagination.total);
      this.collection=[];
       for(let i =0 ; i<= k; i++) {
         this.collection.push(i)
       }
    });
    $(window).scrollTop(0);
  }
  constructor(private http: HttpClient  , public globals: Globals, private route: ActivatedRoute , public sanitizer: DomSanitizer) {

   }

  ngOnInit() {

    this.changel()
    $(window).scrollTop(0);



  }
  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  };

  changel(){
    this.changeReq();

  }
changeReq(){
  $(window).scrollTop(0);
  this.http.get<Photos>(this.globals.urlMain +'pictures', {
    params:{
       page: this.p,

    }

  }).subscribe(data => {
    this.photos = data;

    // console.log(this.slider)
    var k =Number(data.data.item.pagination.total);
   this.collection=[];
    for(let i =0 ; i<= k; i++) {
      this.collection.push(i)
    }


  });



}

openModal(event) {
  $('.modalForVideos').addClass('shown')
  var target = event.target || event.srcElement || event.currentTarget;
  // var title = $(target).closest('.iframe').find('.title').text();
  var iframe = $(target).closest('.iframe').find('img').attr('data-id');
  var newIframe = document.createElement('iframe');
  newIframe.src = iframe;
  newIframe.height="100%";
  newIframe.width="100%";
  newIframe.allowFullscreen= true;
  // $('.modalTitle').html(title);
  $('.modileIframe').html(newIframe);

}
  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }
}
